// extracted by mini-css-extract-plugin
module.exports = {"label":"_02712f2b3b--label--bSiVV","price":"_02712f2b3b--price--joswk","description":"_02712f2b3b--description--J94UV","link":"_02712f2b3b--link--dYkW6"};